// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GAEvents from "../../../../library/ga/GAEvents.bs.js";
import * as ReactModal from "react-modal";
import * as Icon$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as VehicleConfig from "../../../../common/store/VehicleConfig.bs.js";
import * as InsuranceStoreEn from "../../repo/store/InsuranceStoreEn.bs.js";
import * as IneligibleCardUtil from "../utils/IneligibleCardUtil.bs.js";
import * as Timestamp$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ViewUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ViewUtils.bs.js";
import * as InsuranceAssetsManager from "../assets/InsuranceAssetsManager.bs.js";
import * as ReasonReactUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ReasonReactUtils.bs.js";
import * as InsuranceEligibilityRequirementCmp from "./InsuranceEligibilityRequirementCmp.bs.js";

var youtubeIcon = InsuranceAssetsManager.getImage("youtube.svg");

function InsurancePlanCmp$InsuranceVideo(Props) {
  var link = Props.link;
  var closeModal = Props.closeModal;
  var showModalOpt = Props.showModal;
  var showModal = showModalOpt !== undefined ? showModalOpt : false;
  return React.createElement(ReactModal, {
              isOpen: showModal,
              onRequestClose: (function (param) {
                  return Curry._1(closeModal, undefined);
                }),
              overlayClassName: "insurance-video-overlay",
              className: "insurance-video-modal",
              ariaHideApp: false,
              children: React.createElement("div", {
                    className: "insurance-marketing-video"
                  }, React.createElement("div", {
                        className: "insurance-video-close-btn",
                        onClick: (function (param) {
                            return Curry._1(closeModal, undefined);
                          })
                      }, React.createElement(Icon$Catalyst.CloseIcon.make, {})), React.createElement("iframe", {
                        className: "componentClassName-video",
                        autoPlay: true,
                        preload: "metadata",
                        src: link
                      }))
            });
}

var InsuranceVideo = {
  make: InsurancePlanCmp$InsuranceVideo
};

function InsurancePlanCmp(Props) {
  var data = Props.data;
  var content = Props.content;
  var eligibility_status = Props.eligibility_status;
  var geo_region = Props.geo_region;
  var category = Props.category;
  React.useEffect((function () {
          GAEvents.publishPageView("dashboard/health_insurance", "Porter Partner Care Dashboard", undefined);
          
        }), []);
  var match = React.useState(function () {
        return false;
      });
  var setShowVideo = match[1];
  return React.createElement("div", {
              className: "c-insurance-plan",
              id: "main-container"
            }, React.createElement("div", {
                  className: "card-container insurance-header",
                  id: "header"
                }, React.createElement("h2", {
                      id: "header-title"
                    }, content.title), React.createElement("p", {
                      id: "header-content"
                    }, content.insurance_provided_by + ":", React.createElement("span", undefined, content.insurance_provider))), eligibility_status ? React.createElement(React.Fragment, undefined, React.createElement(InsuranceEligibilityRequirementCmp.make, {
                        text: IneligibleCardUtil.getIneligibleCardString(geo_region, category, VehicleConfig.vehicleGeoregionConfig, content)
                      }), React.createElement("div", {
                        className: "card-container policy-covers",
                        id: "policy-coverage-details"
                      }, React.createElement("div", {
                            className: "card"
                          }, React.createElement("p", undefined, content.coverage + "*"), React.createElement("p", {
                                className: "heading-right"
                              }, content.sum_insured)), React.createElement("div", {
                            key: "group-health",
                            className: "card card-blue"
                          }, React.createElement("p", undefined, content.hospitalization), React.createElement("p", undefined, " ₹" + InsuranceStoreEn.groupHealthInsuranceSumInsuredIneligible)), React.createElement("div", {
                            key: "personal-accidental",
                            className: "card card-blue"
                          }, React.createElement("p", undefined, content.accidental), React.createElement("p", undefined, " ₹" + InsuranceStoreEn.groupPersonalAccidentalSumInsuredIneligible)), React.createElement("p", {
                            className: "policy-note"
                          }, "*" + content.as_per_the_policy))) : (
                data !== undefined ? React.createElement(React.Fragment, undefined, React.createElement("div", {
                            className: "card-container policy-details",
                            id: "policy-details-container"
                          }, React.createElement("p", undefined, content.name + ":", React.createElement("span", undefined, data.beneficiary_name)), React.createElement("p", undefined, content.policy_number + ":", React.createElement("span", undefined, data.policy_number)), React.createElement("p", undefined, content.validity + ":", React.createElement("span", undefined, Timestamp$Catalyst.toString(data.policy_start_date, "DD MMM YYYY") + " - " + Timestamp$Catalyst.toString(data.policy_end_date, "DD MMM YYYY")))), React.createElement("div", {
                            className: "card-container policy-covers",
                            id: "policy-coverage-details"
                          }, React.createElement("div", {
                                className: "card"
                              }, React.createElement("p", undefined, content.coverage + "*"), React.createElement("p", {
                                    className: "heading-right"
                                  }, content.sum_insured)), ReasonReactUtils$Catalyst.listToReactArray(List.map((function (e) {
                                      var match = e.cover_id;
                                      var tmp;
                                      switch (match) {
                                        case "accidental" :
                                            tmp = content.accidental;
                                            break;
                                        case "hospitalization" :
                                            tmp = content.hospitalization;
                                            break;
                                        default:
                                          throw {
                                                RE_EXN_ID: "Match_failure",
                                                _1: [
                                                  "InsurancePlanCmp.res",
                                                  125,
                                                  19
                                                ],
                                                Error: new Error()
                                              };
                                      }
                                      return React.createElement("div", {
                                                  className: "card card-blue"
                                                }, React.createElement("p", undefined, tmp), React.createElement("p", undefined, ViewUtils$Catalyst.toAmountString(e.sum_insured)));
                                    }), data.coverages)), React.createElement("p", {
                                className: "policy-note"
                              }, "*" + content.as_per_the_policy))) : null
              ), React.createElement("div", {
                  className: "card-container link-section",
                  id: "last-section"
                }, content.videoUrl !== "" ? React.createElement("div", {
                        className: "card card-blue",
                        id: "benefits-card",
                        onClick: (function (param) {
                            GAEvents.publishEvent("Porter Partner Care", "Click_on_Benefits", undefined, "Benefits_Video", undefined, undefined);
                            return Curry._1(setShowVideo, (function (param) {
                                          return true;
                                        }));
                          })
                      }, React.createElement("div", {
                            className: "video-icon",
                            id: "video-icon"
                          }, React.createElement("img", {
                                src: youtubeIcon
                              }), React.createElement("p", undefined, content.benefits)), React.createElement("p", undefined, content.view_video)) : null, React.createElement("p", {
                      className: "contact-no",
                      id: "contact-details"
                    }, React.createElement("a", {
                          href: "tel:+919853485348"
                        }, content.call + " 09853485348")), React.createElement("a", {
                      className: "contact",
                      id: "tnc-link",
                      onClick: (function (param) {
                          GAEvents.publishEvent("Porter Partner Care", "Click_on_T&C", undefined, "T&C", undefined, undefined);
                          PartnerAppInterface.launchExternalUrl("https://frontend-assets-v2.s3.ap-southeast-1.amazonaws.com/PPC+T%26C.pdf");
                          
                        })
                    }, content.tnc), content.videoUrl !== "" ? React.createElement(InsurancePlanCmp$InsuranceVideo, {
                        link: content.videoUrl,
                        closeModal: (function (param) {
                            return Curry._1(setShowVideo, (function (param) {
                                          return false;
                                        }));
                          }),
                        showModal: match[0]
                      }) : null));
}

var make = InsurancePlanCmp;

export {
  youtubeIcon ,
  InsuranceVideo ,
  make ,
  
}
/* youtubeIcon Not a pure module */
